module.exports = __webpack_public_path__ + "static/media/hat-santa.95b2fec6.svg";